import { ReactNode } from 'react'
import { Col, Flex, Row, Typography } from 'antd'
import useWindowSize from '../../../../../hooks/window-size-hook'
import DetailMenuProject from '../components/layout/DetailMenu.Project'
import { LIST_MENU_DETAIL_MY_TASKS } from '../../../constants/list-menu.quan-ly-giao-viec'

const { Title } = Typography

interface IProps {
  children: ReactNode
}

const LayoutMyTasks = ({ children }: IProps) => {
  const { isSmallSize } = useWindowSize({ options: { needWindowSize: false } })

  return (
    <Flex vertical style={{ marginTop: 16 }}>
      <Row gutter={12} wrap={false} align="middle">
        <Col flex="auto">
          <Title
            level={isSmallSize ? 4 : 2}
            style={{ margin: 0 }}
            ellipsis={{ tooltip: true }}
          >
            Công việc của tôi
          </Title>
        </Col>

        <Col>
          <DetailMenuProject detailMenuItems={LIST_MENU_DETAIL_MY_TASKS} />
        </Col>
      </Row>

      {children}
    </Flex>
  )
}

export default LayoutMyTasks
